import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
var state = {
  config:{
    car: "第七代天籁",
      carName:"",
      outColor: '天际红',
      innerColor: '米色',
      carType: 1,
      options:[]
  }
}
const store = new Vuex.Store({
  state,
  mutations:{
    setData(state, param) {

      var val = param.val;
      if (typeof param.val == "object") {
        val = JSON.stringify(val);
      }
      eval(`state.${param.key}=val`);
    }
  }
})
export default store;
